<template>
    <div>
        <p>ტესტის რეგისტრაცია</p>
        <form class="w3-container w3-half w3-light-grey"
        @submit.prevent="saveTest()">
            <p>
              <label>გაცემის თარიღი/raport date </label>
              <input class="w3-input w3-border"
              type="text"
              v-model="testData.reportDate"
              >
            </p>
            <p>
                <label>დრო/report time </label>
                <input class="w3-input w3-border"
                v-model="testData.reportTime" type="text">
            </p>
            <div>
                <p class="w3-large">patient</p>
                <p>
                    <label>პაციენტის სახელი/patient name</label>
                    <input class="w3-input w3-border"
                    v-model="testData.patient.name" type="text">
                </p>
                <p>
                    <label>სქესი/sex</label><br>
                    <span>
                        <input class="w3-radio"
                        type="radio" value="female" name="sex" id="radio-female" v-model="testData.patient.sex">
                        <label for="radio-female"> მდ./Female</label>
                    </span><br>
                    <span>
                        <input class="w3-radio "
                        type="radio" value="male" name="sex" id="radio-male" v-model="testData.patient.sex">
                        <label for="radio-male"> მამრ.Male</label>
                    </span>
                </p>
                <p>
                    <label>დაბადების თარიღი/birth date</label>
                    <input class="w3-input w3-border"
                    v-model="testData.patient.dateOfBirth"
                    type="text">
                </p>
                <p>
                    <label>ტელ/TEL</label>
                    <input class="w3-input w3-border"
                    type="text" 
                    v-model="testData.patient.tel">
                </p>
                <p>
                    <label>ელ.ფოსტა/eMail</label>
                    <input class="w3-input w3-border"
                    type="email" v-model="testData.patient.email">
                </p>
            </div>
            <div>
                <p>Sample</p>
                <p>
                    <label>ლაბორატორიული კვლევის შედეგი/result number</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.laboratoryTestResultNumber">
                </p>
                <p>
                    <label >ნიმუშის საიდენტიფიკაციო ნომერი/sample ID</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sampleId">
                </p>
                <p>
                    <label >სამეცნიერო პროექტი/Scientific Project</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.scientificProject">
                </p>
                <p>
                    <label >ნიმუშის აღების თარიღი/Date Of Sampling</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sample.dateOfSampling"><br>
                    <label >დრო/Time Of Sampling</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sample.dateOfSamplingTime">
                </p>
                <p>
                    <label >ნიმუშის მიღების თარიღი/Date Of Sample Receiving</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sample.dateOfSampleReceiving"><br>
                    <label >დრო/Time Of Sample Receiving</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sample.dateOfSampleReceivingTime">
                </p>
                <p>
                    <label >
                        დკსჯეც-ის კვლევის შედეგის მიმღები ეპიდემიოლოგი:
                        NCDC’s Epidemiologist receiving laboratory test results:
                    </label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.ncdcEpidName">
                </p>
                <p>
                    <label >Sample Type</label>
                    <input class="w3-input w3-border"
                    type="text" v-model="testData.sample.type">
                </p>
                <p>
                    <label >Sample Condition</label><br>
                    <input class="w3-radio"
                    type="radio" name="sample-cond" id="sample-cond-satisying" value="satisfying" v-model="testData.sample.cond">
                    <label for="sample-cond-satisying">დამაკმაყოფილებელი/satisying</label><br>
                    <input class="w3-radio"
                    type="radio" name="sample-cond" id="sample-cond-not-satisying" value="notsatisfying" v-model="testData.sample.cond">
                    <label for="sample-cond-not-satisying">არადამაკმაყოფილებელი/not satisying</label>
                </p>
                <p>
                    <label for="note-text">შენიშვნა/Note</label>
                    <input class="w3-input"
                    type="text" id="note-text" v-model="testData.sample.note">
                </p>
            </div>
            <div>
                <p>requester</p>
                <button @click.prevent="prefillData('newVision')">ნიუ ვიჟენი</button>
                <button @click.prevent="prefillData('wminda')">წმინდა..</button>
                <button @click.prevent="prefillData('gudushauri')">ღუდუშაური</button>
                <button @click.prevent="prefillData('teaGersamia')">თეა გერსამია</button>
                <button @click.prevent="prefillData('nunuRatiani')">ნუნუ რატიანი</button>

                <p>
                    <label>დამკვეთის სახელი, გვარი/requester name</label>
                    <input class="w3-input"
                    type="text" v-model="testData.requestor.name">
                </p>
                <p>
                    <label>ტელ/Tel</label>
                    <input class="w3-input"
                    type="text" v-model="testData.requestor.tel"> 
                </p>
                <p>
                    <label>დაწესებულება/institution</label>
                    <input class="w3-input" type="text" v-model="testData.requestor.institution">
                </p>
                <p>
                    <label>განყოფილება/Unit</label>
                    <input class="w3-input" type="text" v-model="testData.requestor.unit">
                </p>
                <p>
                    <label>ელ.ფოსტა/eMail</label>
                    <input class="w3-input" type="email" v-model="testData.requestor.email">
                </p>
                <p>
                    <label>მისამართი/Address</label>
                    <input class="w3-input" type="text" v-model="testData.requestor.address">
                </p>
                <p>
                    <label>მოთხოვნილი გამოკვლევა/Requested examination</label>
                    <input class="w3-input" type="text" v-model="testData.requestor.requestedExamination">
                </p>
            </div>
            <div>
                <p>
                    <label>შედეგი/Test Result</label>
                    <select class="w3-select"
                    v-model="testData.testResult">
                        <option value="Positive(+)">Positive(+)</option>
                        <option value="Negative(-)">Negative(-)</option>
                    </select>
                </p>
            </div>
            <button type="submit" :disabled="isLoading">Save</button><label class="w3-yellow" v-if="isLoading">იტვირთება</label><label class="w3-green" v-if="isSuccess">წარმატებით ჩაიწერა</label><label class="w3-red" v-if="isFailed">მონაცემების ჩაწერა ვერ მოხერხდა</label>
      </form>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from 'vuex';
var api_path = "/php_scripts/";
if (process.env.NODE_ENV === "development") {
  api_path = "http://localhost/php_scripts/";
}
export default {
    name: 'RegisterCovidTest',
    props: ['patientId'],
    data: () => {
        return {
            isLoading: false,
            isSuccess: false,
            isFailed: false,
            testData: {
                reportDate: null,
                reportTime: null,
                patient: {
                    name: null,
                    sex: null,
                    dateOfBirth: null,
                    tel: null,
                    email: null,
                },
                laboratoryTestResultNumber: null,
                sampleId: null,
                scientificProject: null,
                ncdcEpidName: null,
                sample: {
                    dateOfSampling: null,
                    dateOfSamplingTime: null,
                    dateOfSampleReceiving: null,
                    dateOfSampleReceivingTime: null,
                    type: null,
                    cond: null,
                    note: null,
                },
                requestor: {
                    name: null,
                    tel: null,
                    institution: null,
                    unit: null,
                    email: null,
                    address: null,
                    requestedExamination: null,
                },
                testResult: null,
            }
        }
    },
    created() {
        if (this.$route.query.testId) {
            console.log('fetching testId: ', this.$route.query.testId)
            axios
                .get(api_path + 'get_covit_test_by_test_id.php', {
                    params: {
                        test_id: this.$route.query.testId
                    }
                })
                .then((response) => {
                    this.testData = JSON.parse(response.data.covid_data)
                    console.log(this.testData);
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    },
    methods: {
        ...mapActions({saveCovidTest:'SAVE_COVID_TEST', updateCovidTest:'UPDATE_COVID_TEST'}),
        saveTest: function() {
            console.log('now save: ', this.patientId, this.testData)
            this.isLoading = true
            this.isSuccess = false
            this.isFailed = false
            // testId: this.$route.query ? this.$route.query.testId : null,
            if (this.$route.query.testId) {
                this.updateCovidTest({
                    testId: this.$route.query.testId,
                    ...this.testData,
                }).then((data) => {
                    this.isLoading = false
                    this.isSuccess = true
                }).catch((err) => {
                    console.log(err)
                    this.isLoading = false
                    this.isFailed = true
                })
            } else {
                this.saveCovidTest({
                    ...this.testData,
                    patientId: this.patientId,
                }).then((data) => {
                    this.isLoading = false
                    this.isSuccess = true
                }).catch((err) => {
                    console.log(err)
                    this.isLoading = false
                    this.isFailed = true
                })
            }
        },
        prefillData(hospitalName) {
            this.testData.requestor = {
                name: null,
                tel: null,
                institution: null,
                unit: null,
                email: null,
                address: null,
                requestedExamination: null,
            }
            const newVision = {
                name: 'თამარ ქისტაური',
                tel: '593 625 232',
                institution: '„ნიუ ვიჟენ საუნივერსიტეტო ჰოსპიტალი“',
                unit: 'სტაციონარი',
                email: 'hospital@newVision.ge',
                address: 'თბილისი,ლუბლიანას ქუჩა N13,მიხეილ ჭიაურელის ქუჩა N6',
                requestedExamination: 'კორონა ვირუსზე პჯრ კვლევა',
            }
            const wminda = {
                name: 'ვერე ჯიქია',
                tel: '593 74 51 14',
                institution: 'შპს წმინდა მიქაელ მთავარანგელოზის სახელობის მრავალპროფილიანი კლინიკური საავადმყოფო',
                unit: 'სტაციონარი',
                email: 'tsu_klinika@mail.ru',
                address: 'თბილისი,ლუბლიანას ქ.N31',
                requestedExamination: 'კორონა ვირუსზე პჯრ კვლევა',
            }
            const gudushauri = {
                name: 'ხათუნა ალადაშვილი',
                tel: '595 50 28 59',
                institution: 'შპს აკადემიკოს ო.ღუდუშაურის სახელობის ეროვნული სამედიცინო ცენტრი',
                unit: '',
                email: 'info@gudushauri.ge',
                address: 'თბილისი, ნოდარ ბოხუას ქ.N12/ლუბლიანას ქ.N66',
                requestedExamination: 'კორონა ვირუსზე პჯრ კვლევა',
            }
            const teaGersamia = {
                name: 'თეა გერსამია',
                tel: '577 34 10 01',
                institution: 'სსიპ - საგანგებო სიტუაციების კოორდინაციისა და გადაუდებელი დახმარების ცენტრი',
                unit: '',
                email: '',
                address: 'ქ.თბილისი, აკ.წერეთლის გამზ.117',
                requestedExamination: 'კორონა ვირუსზე პჯრ კვლევა',
            }
            const nunuRatiani = {
                name: 'ნუნუ რატიანი',
                tel: '591 93 03 13',
                institution: 'სსიპ - საგანგებო სიტუაციების კოორდინაციისა და გადაუდებელი დახმარების ცენტრი',
                unit: '',
                email: '',
                address: 'ქ.თბილისი, აკ.წერეთლის გამზ.117',
                requestedExamination: 'კორონა ვირუსზე პჯრ კვლევა',
            }

            if (hospitalName === 'newVision') {
                this.testData.requestor = newVision
            }
            if (hospitalName === 'wminda') {
                this.testData.requestor = wminda        
            }
            if (hospitalName === 'gudushauri') {
                this.testData.requestor = gudushauri        
            }
            if (hospitalName === 'teaGersamia') {
                this.testData.requestor = teaGersamia        
            }
            if (hospitalName === 'nunuRatiani') {
                this.testData.requestor = nunuRatiani       
            }
        }
    }
}
</script>

<style>

</style>